// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3JZS1","content":"ManualTimeModal_content__2JLSp"};